import React from 'react';
import { ISearchResultsRowMap } from '../utils';
import WellDropImageLoader from 'components/searchAndFilter/components/WellDropImageLoader';

interface Props {
  latestSelectedRow: ISearchResultsRowMap;
}
const ImgView = (props: Props) => {
  const { latestSelectedRow } = props;

  if (!latestSelectedRow) {
    return null;
  }
  return (
    <div
      id="searchandfilter-imgview-wrapper"
      className="w-full h-[28vh] flex justify-center items-center py-[10px]"
    >
      <WellDropImageLoader
        captureProfileId={latestSelectedRow.captureProfileId}
        plateId={latestSelectedRow.plateId}
        wellNumber={latestSelectedRow.wellNumber}
        batchId={latestSelectedRow.batchId}
        dropNumber={latestSelectedRow.dropNumber}
        regionId={latestSelectedRow.regionID}
        useCanvasImage={false}
        key={`Wi-${Object.values(latestSelectedRow).join('-')}`}
      />
    </div>
  );
};

export default ImgView;
